export class DatatableParameters {
    constructor(
        public columns: any[],
        public length: number,
        public order: any[],
        public start: number,
        public lengthMenu?: any[] //Ex. [[10, 25, 50, 100], [10, 25, 50, 'Todos']] primeiro array é o valor e o segundo array é a descrição
    ) { }
}
